<template>
  <div
    class="w-full h-full visualization-cockpit flex bg-no-repeat"
    :class="`visualization-${currentTheme}`"
  >
    <div
      class="bg-no-repeat relative w-full h-full z-10"
      :class="isPreview && isSplitScreen ? '!w-1/2' : ''"
    >
      <div
        class="visualization-cockpit-left absolute left-0 bg-no-repeat h-full z-8"
        :class="visualizationLeftClass"
        v-if="showLeftMask"
      ></div>
      <div
        class="visualization-cockpit-right absolute right-0 bg-no-repeat h-full z-8"
        :class="visualizationRightClass"
        v-if="showRightMask"
      ></div>
      <div
        v-if="showControlPanel"
        class="w-40px h-40px absolute left-20px bottom-20px z-999 control-panel transition-all cursor-pointer"
        @click="changePanel"
        :class="!collapsePanel ? 'collapse' : 'unfold'"
      ></div>
      <ModelPreview
        v-if="isPreview"
        @sendPlayer="sendPlayer"
        :modelDetail="modelDetail"
        :sourceId="moduleRelationSceneId"
        :cloudRender="cloudRender"
        :modelEngineTransform="modelEngineTransform"
        @loadModelEnd="loadModelEnd"
        @updateModelNode="updateModelNode"
      ></ModelPreview>
      <GXModelView
        v-else-if="isGXView"
        @sendPlayer="sendPlayer"
        :GXRunPlayer="GXRunPlayer"
        :modelDetail="modelDetail"
        :cloudRender="cloudRender"
        :loadModelNode="loadModelNode"
        @loadModelEnd="loadModelEnd"
        @loadingSwitch="loadingSwitch"
        @updateModelNode="updateModelNode"
      ></GXModelView>
      <GisView v-else-if="isLoadGIS"> </GisView>
      <ModelView
        v-else
        loadModelType="sceneId"
        :sourceId="moduleRelationSceneId"
        :modelTreeProp="customProps.modelTreeProp"
        :cloudRender="cloudRender"
        :collisionReload="collisionReload"
        :moveVisualAngleFlag="moveVisualAngleFlag"
        :modelEngineTransform="modelEngineTransform"
        @sendPlayer="sendPlayer"
        @loadModelEnd="loadModelEnd"
        @setSceneOptions="setSceneOptions"
        @loadingSwitch="loadingSwitch"
        :modelWidth="modelWidth"
        @updateModelNode="updateModelNode"
        @animationEnd="animationEnd"
      ></ModelView>
      <!-- 右键菜单 -->
      <right-click-menu
        v-if="!_.isNil(player) && mode === 'visualization' && !isLoadGIS && isOpenRightMenu"
        :player="player"
      ></right-click-menu>
      <component
        v-if="!isPreview && !isGXView"
        :is="visualizationHeaderCom"
        :hiddenSwitchButton="hiddenSwitchButton"
        :previewSchemeId="previewSchemeId"
        :previewLogo="previewLogo"
        :showIf="showIf"
        :loadModelStatus="customProps.loadModelStatus || isLoadGIS"
        @changeModule="changeModule"
        :defaultSection="defaultSection"
        :alarmJumpSection="alarmJumpSection"
        class="z-11"
        :isSubTenantCheck="isSubTenantCheck"
        @toggleMode="toggleMode"
        @openAlarmList="alarmListVisible = true"
        @openAlarmListDyw="alarmListVisibleDyw = true"
      ></component>
      <BasicTab
        :tabList="basicFunctionList"
        v-show="mode === 'visualization' && !isLoadGIS"
        @tabsClick="tabsClick(arguments, 'basic')"
        :selectTagList="activeBasicList"
        :activeTag="activeBasic"
      ></BasicTab>
      <!-- 左侧业务菜单列表 -->
      <BusinessTab
        position="left"
        :tabList="businessLeftTabList"
        :selectTab="[leftSelectTab, rightSelectTab]"
        :jumpFunction="jumpFunction"
        @tabsClick="tabsClick(arguments, 'business')"
        class="z-11"
        v-show="mode === 'visualization' && !isLoadGIS"
      ></BusinessTab>
      <!-- 右侧业务菜单列表 -->
      <BusinessTab
        v-if="visualizationConfig.showRightPanel"
        position="right"
        :tabList="businessRightTabList"
        :selectTab="[leftSelectTab, rightSelectTab]"
        :jumpFunction="jumpFunction"
        @tabsClick="tabsClick(arguments, 'business')"
        class="z-11"
        v-show="mode === 'visualization' && !isLoadGIS"
      ></BusinessTab>
      <visualization-function-list
        v-if="showFunctionLabels && !isLoadGIS"
        v-show="mode === 'visualization'"
        class="absolute z-12"
        :player="player"
        :class="leftBaseProps.currentComponent.code && !collapsePanel ? 'left-470px' : 'left-90px'"
        :lableDtos="lableDtos"
        :defaultLableDtos="defaultLableDtos"
        :openLableList="businessTabConfigs"
        :noticeCloseComponent="noticeCloseComponent"
        :sourceId="moduleRelationSceneId"
        :cloudRender="cloudRender"
        :collapseLabels="collapsePanel"
        @updateLabel="updateLabel(arguments)"
        @closeTrajectory="trajectoryVisible = false"
        @JobVisualization="handleJobArea"
      ></visualization-function-list>
      <!-- 左侧容器组件 -->
      <ComponentContainer
        :style="{
          left: collapsePanel ? '-400px' : _.isEmpty(businessLeftTabList) ? '20px' : '100px',
        }"
        key="leftContainer"
        v-if="leftBaseProps.currentComponent.code"
        v-show="mode === 'visualization' && !isLoadGIS"
        :player="player"
        :modelLoadEnd="modelLoadEnd"
        :baseProps="leftBaseProps"
        :customProps="customProps"
        :noticeCloseComponent="noticeCloseComponent"
        :noticeCloseLabel="noticeCloseLabel"
        :transferProps="leftTransferProps"
        :cloudRender="cloudRender"
        :labelList="labelList"
        :sourceId="moduleRelationSceneId"
        :showDocumentDialog="showDocumentDialog"
        :modelNode="modelNode"
        :onlineTagList="onlineTagList"
        :mode="mode"
        :modelDetail="modelDetail"
        :currentNode="currentNode"
        :deviceInfo="deviceInfo"
        :zIndexClassName="'z-997'"
        @doLocation="doLocation"
        @collisionReload="collisionReloadHandler"
        @transferEvent="leftTransferEvent"
        @closeComponent="leftCloseComponent"
        @selectTab="changeLeftSelectTab"
        @operateTrajectory="operateTrajectory"
        @loadingSwitch="loadingSwitch"
        @changeModel="changeModel"
        @updateDeviceInfo="updateDeviceInfo"
      ></ComponentContainer>
      <!-- 右侧容器组件 -->
      <ComponentContainer
        :style="{
          right: collapsePanel
            ? '-400px'
            : _.isEmpty(businessRightTabList) || !visualizationConfig.showRightPanel
            ? '20px'
            : '100px',
        }"
        key="rightContainer"
        v-if="rightBaseProps.currentComponent.code"
        ref="rightComponentContainer"
        v-show="mode === 'visualization' && !isLoadGIS"
        :player="player"
        :baseProps="rightBaseProps"
        :customProps="customProps"
        :modelNode="modelNode"
        :noticeCloseComponent="noticeCloseComponent"
        :noticeCloseLabel="noticeCloseLabel"
        :transferProps="rightTransferProps"
        :cloudRender="cloudRender"
        :labelList="labelList"
        :sourceId="moduleRelationSceneId"
        :showObjInfoDialog="showObjInfoDialog"
        :onlineTagList="onlineTagList"
        :materialObj="materialObj"
        :mode="mode"
        :zIndexClassName="'z-997'"
        @transferEvent="rightTransferEvent"
        @closeComponent="rightCloseComponent"
        @selectTab="changeRightSelectTab"
        @showVideoWall="videoWallVisible = !videoWallVisible"
        @operateTrajectory="operateTrajectory"
        @PersonnelInfo="handlePersonnelInfo"
      ></ComponentContainer>
      <!-- 全屏组件 -->
      <FullScreenContainer
        :style="{ left: collapsePanel ? '-1980px' : '75px' }"
        key="fullScreenContainer"
        :player="player"
        :baseProps="fullScreenBaseProps"
        v-if="fullScreenBaseProps.currentComponent.code"
        :customProps="customProps"
        :noticeCloseComponent="noticeCloseComponent"
        :noticeCloseLabel="noticeCloseLabel"
        :transferProps="fullScreenTransferProps"
        :cloudRender="cloudRender"
        :labelList="labelList"
        :sourceId="moduleRelationSceneId"
        @transferEvent="fullScreenTransferEvent"
        @closeComponent="fullScreenCloseComponent"
      ></FullScreenContainer>
      <!-- 屏幕闪烁组件 -->
      <AlarmFlicker
        v-if="openAlarmFlicker"
        :frequency="alarmFlickerFrequency"
        :isFlicker="openAlarmFlicker"
      ></AlarmFlicker>
      <AlarmNotification
        v-show="alarmNotificationNum && mode === 'visualization' && !isLoadGIS"
        @alarmJump="alarmJump(arguments)"
        @getAlarmNum="(num) => (alarmNotificationNum = num)"
      ></AlarmNotification>
      <ObjectInfoDyw
        v-if="modelWidth === 1 / 2"
        :width="objInfoWidth"
        :height="objInfoHeight"
        top="100px"
        right="0px"
        @closeObjInfo="closeObjInfo"
        @exitScreen="exitScreen"
        type="screen"
        :dialogForm="objInfoMsg"
        :player="player"
        :module="moduleType"
        :standardId="standardId"
      ></ObjectInfoDyw>
      <!-- 电视墙 -->
      <VideoWall
        class="absolute left-22/100 right-22/100 bottom-36/100 top-0/100 z-20"
        @close="videoWallVisible = false"
        v-if="videoWallVisible"
        :videoWallVisible="videoWallVisible"
      />
      <trajectory
        v-if="trajectoryVisible"
        :cloudRender="cloudRender"
        @closeTrajectory="trajectoryVisible = false"
        @loadHistoryTrialEnd="loadHistoryTrialEnd"
        :personnelId="trajectoryProps.personnelId"
        :tagCode="trajectoryProps.tagCode"
        :modelId="moduleRelationSceneId"
        :cancelFollowAble="false"
      ></trajectory>
      <!-- 宇视云台 -->
      <CameraPicture
        :deviceCode="cameraPictureTarget.deviceCode"
        :plid="cameraPictureTarget.plid"
        @refresh="refresh"
        v-if="cameraPictureTarget.isShowDialog"
        class="w-970px h-500px"
      ></CameraPicture>
      <!-- 摄像头三维标签弹窗 -->
      <videoDialog
        v-if="videoDialogTarget.isShowDialog"
        :show.sync="videoDialogTarget.isShowDialog"
        :code="videoDialogTarget.code"
        :name="videoDialogTarget.name"
        :pIid="videoDialogTarget.pIid"
        :showControlPanel="true"
        :manufacturerCode="videoDialogTarget.manufacturerCode"
        :daHuaParams="videoDialogTarget"
      ></videoDialog>
      <!-- 大亚湾定制功能 start -->
      <EmergencyDisposalDyw
        :collapsePanel="collapsePanel"
        v-if="emergencyDisposalDyw.isShowDialog"
        :player="player"
        :cloudRender="cloudRender"
        @openRight="leftTransferEvent"
        @openLeft="rightTransferEvent"
        @close="emergencyDisposalDyw.isShowDialog = false"
      >
      </EmergencyDisposalDyw>
      <!-- 大亚湾定制功能 end -->
    </div>
    <div class="w-1/2" v-if="isPreview && isSplitScreen">
      <SplitScreen
        @closeObjectFileSplit="closeObjectFileSplit"
        :dialogForm="objInfoMsg"
        :player="player"
        :standardId="standardId"
      ></SplitScreen>
    </div>
    <!-- 层级高的部分组件 -->
    <AlarmCenter
      v-if="alarmListVisible"
      :visible.sync="alarmListVisible"
      @alarmJump="alarmJump(arguments)"
    ></AlarmCenter>
    <AlarmCenterDyw
      v-if="alarmListVisibleDyw"
      @openRight="leftTransferEvent"
      @openPersonAlarmList="personAlarmListVisible = true"
      :visible.sync="alarmListVisibleDyw"
    ></AlarmCenterDyw>
    <PersonAlarmList
      v-if="personAlarmListVisible"
      :alarmListVisible.sync="personAlarmListVisible"
    ></PersonAlarmList>
    <CollisionEditPage
      :collisionDetail="collisionDetail"
      @closeCollisionEdit="closeCollisionEdit"
      class="w-970px h-530px"
      v-if="collisionEditShow"
    ></CollisionEditPage>
  </div>
</template>
<script>
import {
  SectionApi,
  FunctionInfoApi,
  ModelGenericConfigurationApi,
} from '@wiz-api/cloud-render-management'
import { SectionApi as HuizhouSectionApi } from '@wiz-api/huizhou2'
import { ModelApi } from '@wiz-api/material-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { instance as cloudRender } from 'wiz-cloud-render-vulkan'
import EventBusHz from '@/assets/js/EventBus'
import { ModelSceneApi } from '@wiz-api/scene-management'
import { initActiveBasicTab, destroyCloseBasicTab } from '../assets/js/model/commonMethods'
import ModelView from '../components/model/ModelView'
import GisView from '../components/model/GisView'
import ModelPreview from '../components/model/ModelPreview'
import GXModelView from '../components/model/GXModelView'
import CockpitHeader from '../components/tool/CockpitHeader'
import CockpitHeaderDj from '../components/tool/CockpitHeaderDj'
import CockpitHeaderDyw from '../components/tool/CockpitHeaderDyw'
import BusinessTab from '../components/tool/BusinessTab'
import BasicTab from '../components/tool/BaiscTab'
import VisualizationFunctionList from '../components/tool/VisualizationFunctionList'
import setModelVisible from '../assets/js/model/modelTree'
import EventBus from '../assets/js/componentMethods/EventBus'
import HandoverService from '../service/HandoverService'

const modelSceneApi = new ModelSceneApi()
const modelApi = new ModelApi()
const modelGenericConfigurationApi = new ModelGenericConfigurationApi()
const dataCategoryApi = new DataCategoryApi()
const sectionApi = new SectionApi()
const huizhouSectionApi = new HuizhouSectionApi()
const functionInfoApi = new FunctionInfoApi()
const VideoWall = () => {
  return import('../components/business/components/video/YSPlayer/VideoWall')
}
const ComponentContainer = () => {
  return import('../components/tool/ComponentContainer')
}
const AlarmFlicker = () => {
  return import('../components/tool/AlarmFlicker')
}
const FullScreenContainer = () => {
  return import('../components/tool/FullScreenContainer')
}
// 报警消息中心
const AlarmCenter = () => {
  return import('../components/tool/AlarmCenter')
}
// 大亚湾报警消息中心
const AlarmCenterDyw = () => {
  return import('../components/tool/AlarmCenterDyw')
} // 报警列表
const PersonAlarmList = () => {
  return import('../components/business/components/PersonAlarmList')
}

// 报警通知
const AlarmNotification = () => {
  return import('../components/tool/AlarmNotification')
}
// 对象信息
const ObjectInfoDyw = () => {
  return import('../components/business/ObjectInfoDyw/objDialog')
}
// 对象信息-分屏
const SplitScreen = () => {
  return import('../components/business/ObjectInfoDyw/splitScreen')
}

// 历史轨迹
const trajectory = () => {
  return import('../components/business/components/trajectory')
}

const CameraPicture = () => {
  return import('../components/business/components/smartSecurity/cameraPicture')
}
const VideoDialog = () => {
  return import('../components/business/components/video/videoDialog')
}

// 右键菜单
const rightClickMenu = () => {
  return import('../components/basic/RightClickMenu')
}
// 大亚湾应急管理
const EmergencyDisposalDyw = () => {
  return import('../components/business/EmergencyDisposalDyw/index')
}

// 问题详情弹窗
const CollisionEditPage = () => {
  return import('../components/business/CollisionCheck/CollisionEditPage')
}
export default {
  name: 'VisualizationCockpit',
  props: {
    mode: {
      type: String,
      default: 'visualization',
    },
    modelEngineTransform: {
      type: String,
      default: 'scale(1, 1)',
    },
    showIf: {
      type: Boolean,
      default: true,
    },
    isSubTenantCheck: {
      type: Boolean,
      default: false,
    },
    isLoadGIS: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ModelView,
    rightClickMenu,
    CockpitHeader,
    BusinessTab,
    ComponentContainer,
    VisualizationFunctionList,
    BasicTab,
    AlarmFlicker,
    FullScreenContainer,
    AlarmCenter,
    AlarmCenterDyw,
    PersonAlarmList,
    AlarmNotification,
    ObjectInfoDyw,
    SplitScreen,
    VideoWall,
    GisView,
    ModelPreview,
    GXModelView,
    trajectory,
    CameraPicture,
    VideoDialog,
    CockpitHeaderDyw,
    CockpitHeaderDj,
    EmergencyDisposalDyw,
    CollisionEditPage,
  },
  data() {
    return {
      isPreview: false, // 是否是模型预览（从模型管理过来）
      isSplitScreen: false,
      previewSchemeId: null, // 方案预览id
      previewLogo: null, // 方案预览logoid
      videoWallVisible: false,
      // 广西石化定制参数 start
      isGXView: false,
      GXRunPlayer: false,
      animationLoading: false, // 动画状态
      modelLoadEnd: false, // 模型是否加载完毕
      loadingTitle: null, // 动画名称
      currentValve: {
        // 阀门详情信息
        isShowDialog: false,
      },
      currentBlindPlate: {
        // 盲板详情信息
        isShowDialog: false,
      },
      currentChecksAndSets: {
        // 问题详情信息
        isShowDialog: false,
      },
      crossStatus: false, // 断面打开状态
      deviceInfo: {
        // 装置的信息，用于存储已切换的装置
        deviceName: null,
        deviceId: null,
        modelId: null,
      },
      gxCustomFunction: [
        'ChecksAndSets',
        'BlindPlateExhibition',
        'CrossSectionAnalysis',
        'MaterialStatistics',
        'AnticorrosionAndInsulation',
        'ValveManagement',
        'PipeExtraction',
        'PipeFlowAnalysis',
      ],
      // 广西石化定制参数 end
      collisionEditShow: false, // 碰撞编辑
      collisionDetail: {}, // 碰撞详情
      locationType: 5,
      loadModelNode: false, // 针对广西流向功能，使用Node加载
      openAlarmFlicker: false, // 控制报警闪烁
      collisionReload: false,
      alarmFlickerFrequency: 500, // 报警闪烁频率
      currentNode: null,
      materialObj: {},
      collapsePanel: false,
      style: {
        width: 1920,
        height: 1080,
        transform: 'scale(1)',
      },
      // 当前选中的模块
      currentModule: '',
      // 左侧业务tab
      businessLeftTabList: [],
      // 右侧业务tab
      businessRightTabList: [],
      // 业务功能的编码集合
      businessFunctionCodes: '',
      // 基础tab
      basicFunctionList: [],
      // 当前板块所包含的所有标签
      lableDtos: [],
      // 默认激活的标签
      defaultLableDtos: [],
      // 激活的基础功能列表
      activeBasicList: [],
      // 当前激活的功能
      activeBasic: '',
      // 左侧容器传递数据
      leftTransferProps: {},
      // 右侧容器传递数据
      rightTransferProps: {},
      // 全屏容器传递数据
      fullScreenTransferProps: {},
      // 通知关闭组件
      noticeCloseComponent: {},
      // 通知关闭的标签数组
      noticeCloseLabel: [],
      player: null,
      leftSelectTab: '', // 当前激活组件
      rightSelectTab: '', // 当前激活组件
      businessTabConfigs: [], // 业务功能可视化配置
      activeComponentList: [],
      defaultSection: '', // 默认打开的板块
      showHidenCodeList: [
        'system.ToolHideModelSpaceSwap',
        'system.ToolHideModel',
        'system.ToolShowModel',
        'system.ToolShowAll',
        'system.ToolShowSingle',
      ],
      leftBaseProps: {
        location: 'left',
        currentComponent: {},
        coexistenceNum: 3,
      },
      rightBaseProps: {
        location: 'right',
        currentComponent: {},
        coexistenceNum: 3,
      },
      fullScreenBaseProps: {
        location: 'fullSrceen',
        currentComponent: {},
        coexistenceNum: 1,
      },
      customProps: {
        // 模型树相关
        modelTreeProp: {
          currentNodeItem: 0, // 当前激活的node
          currentNodeName: '', // 点选时当前激活的节点名称
          treeData: [], // 模型树数据
          defaultCheckedKey: [], // 模型树选中的节点
          filterItem: [], // 模型树不需要显示的节点及他的父节点列表
          modelHideList: [], // 模型隐藏队列
          modelTreeLoadEnd: false, // 模型树数据加载完毕
          spaceSwapStatus: false, // 交换空间状态
        },
        sceneId: '',
        loadModelStatus: false,
        mode: 'visualization',
      },
      moduleRelationSceneId: '',
      labelList: [],
      openComTypes: ['basic', 'business', 'mainComponent', 'tags', 'openComponent'],
      showFunctionLabels: false,
      alarmListVisible: false, // 报警消息中心弹框显隐
      alarmListVisibleDyw: false, // 大亚湾报警消息中心弹框显隐
      personAlarmListVisible: false, // 报警列表弹框显隐
      alarmJumpSection: {}, // 点击报警消息跳转的板块
      jumpFunction: { code: '' }, // 跳转的功能板块
      isJumpSectionOver: true, // 是否跳转板块完成
      recordCode: '', // 用于记录需要跳转的功能的code
      alarmNotificationNum: 0, // 报警通知的数量
      modelWidth: 1, // 模型宽度
      objInfoWidth: '',
      objInfoHeight: '',
      showObjInfoDialog: false,
      modelDetail: {
        // 模型预览/广西定制功能使用
        filePath: '',
        materialFileId: '',
        modelFileId: '',
      },
      objInfoMsg: {}, // 对象信息的数据
      showDocumentDialog: false,
      moduleType: '',
      moveVisualAngleFlag: false, // 切到初始视角的标识
      modelNode: null, // 点选模型，获取模型的节点node

      // 当前在线人员的标签列表
      onlineTagList: [],
      // 历史轨迹组件
      trajectoryVisible: false,
      trajectoryProps: {
        personnelId: '',
      },
      cameraPictureTarget: {
        isShowDialog: false,
        deviceCode: '',
        plid: '',
      },
      videoDialogTarget: {
        isShowDialog: false,
        code: '',
        name: '',
        pIid: '',
        manufacturerCode: '',
        id: '',
      },
      standardId: '',
      visualizationLableDtos: [],
      visualizationDefaultLableDtos: [],
      cockpitLableDtos: [],
      cockpitDefaultLableDtos: [],
      isOpenDeaultComponent: false, // 是否打开默认组件
      emergencyDisposalDyw: {
        isShowDialog: false,
      },
    }
  },
  computed: {
    // 隐藏驾驶舱/可视化切换按钮
    hiddenSwitchButton() {
      return this.$route.name === 'TongreVulkanIndex'
    },
    // 左侧遮罩样式
    visualizationLeftClass() {
      return this.leftBaseProps.currentComponent.code && !this.collapsePanel
        ? 'left-wide-mask w-269px'
        : 'left-narrow-mask w-90px'
    },
    // 右侧遮罩样式
    visualizationRightClass() {
      if (this.rightBaseProps.currentComponent.code && !this.collapsePanel) {
        return 'right-wide-mask w-269px'
      }
      if (this.visualizationConfig.showRightPanel && !_.isEmpty(this.businessRightTabList)) {
        return 'right-narrow-mask w-90px'
      }
      return ''
    },
    // 显示左侧遮罩
    showLeftMask() {
      return (
        (!_.isEmpty(this.businessLeftTabList) || this.leftBaseProps.currentComponent.code) &&
        this.mode === 'visualization'
      )
    },
    // 显示右侧遮罩
    showRightMask() {
      return (
        ((this.visualizationConfig.showRightPanel && !_.isEmpty(this.businessRightTabList)) ||
          this.rightBaseProps.currentComponent.code) &&
        this.mode === 'visualization'
      )
    },
    // 显示收起/展开按钮
    showControlPanel() {
      return (
        this.leftBaseProps.currentComponent.code ||
        this.rightBaseProps.currentComponent.code ||
        this.fullScreenBaseProps.currentComponent.code ||
        this.emergencyDisposalDyw.isShowDialog
      )
    },
    // 广西石化全场模型名称
    gxBaseModelName() {
      return Wiz.globalSettings.globalConfig?.gxBaseModelName || ''
    },
    // 可视化相关配置
    visualizationConfig() {
      return Wiz.globalSettings.globalConfig?.visualizationConfig || {}
    },
    currentTheme() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-tongre-vulkan"].config')
          ?.currentTheme || 'default'
      )
    },
    // 模型相关设置
    modelSetting() {
      return (
        Wiz.globalSettings.globalConfig?.modelSetting ||
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-tongre-vulkan"].config')
          ?.modelSetting ||
        {}
      )
    },
    // 是否开启模型右键功能
    isOpenRightMenu() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-tongre-vulkan"].config')
          ?.isOpenRightMenu || false
      )
    },
    // 模型文件
    modelFileList() {
      return this.modelSetting.modelFileList || []
    },
    cloudRender() {
      return cloudRender
    },
    metalBIMmodelId() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-tongre-vulkan"].config')
          ?.metalBIMmodelId || '3a0f7d35-e1b4-b198-322d-e2590b6d8528'
      )
    },
    // 可视化头部组件
    visualizationHeaderCom() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-tongre-vulkan"].config')
          ?.headerComponentCode || 'CockpitHeader'
      )
    },
    visualizationCockpitConfig() {
      return _.get(
        Wiz,
        'globalSettings.dynamicModules.modules["visualization-tongre-vulkan"].config'
      )
    },
  },
  async created() {
    this.getDataCategory()
    if (this.$route.query.schemeId) {
      // 从方案管理点击预览
      this.previewSchemeId = this.$route.query.schemeId
      this.previewLogo = this.$route.query.logo
    } else if (this.$route.query.modelInfoId) {
      // 模型预览
      this.modelDetail = Object.assign(this.modelDetail, {
        filePath: `data://../apps/${this.modelSetting.folderName}/models/${this.$route.query.modelInfoId}/${this.$route.query.modelInfoId}.pr`,
        materialFileId: this.$route.query.textureInfoId,
        modelFileId: this.$route.query.modelInfoId,
      })
      this.isPreview = true
      this.getFunctionTabInfo()
    } else if (this.$route.query.proj && this.$route.query.proj === 'gx') {
      // if (this.$route.query.name === 'PipeFlowAnalysis') {
      //   this.loadModelNode = true // 针对液位单独使用node加载，方便加动画
      // }
      this.isGXView = true
      this.getBaseModelInfo()
      this.getGxFunctionInfo(this.$route.query.name)
    }
  },
  mounted() {
    window.addEventListener('openComponent', (e) => {
      const findComponent = _.find(this.activeComponentList, ['code', e.detail.toCom?.origin]) || {}
      switch (findComponent.locationType) {
        case 1:
          if (this.openComTypes.includes(e.detail.type)) {
            this.leftBaseProps.currentComponent = _.cloneDeep(e.detail.toCom)
          }
          this.$set(this.leftTransferProps, e.detail.toCom.code, _.cloneDeep(e.detail.props))
          break
        case 3:
          // 全屏
          if (this.openComTypes.includes(e.detail.type)) {
            this.fullScreenBaseProps.currentComponent = _.cloneDeep(e.detail.toCom)
          }
          this.$set(this.fullScreenTransferProps, e.detail.toCom.code, _.cloneDeep(e.detail.props))
          break
        case 2:
        default:
          if (e.detail.position && e.detail.position === 'left') {
            // 针对单独想打开左侧已有功能
            if (this.openComTypes.includes(e.detail.type)) {
              this.leftBaseProps.currentComponent = _.cloneDeep(e.detail.toCom)
            }
            this.$set(this.leftTransferProps, e.detail.toCom.code, _.cloneDeep(e.detail.props))
          } else {
            // 默认展示在右侧
            if (this.openComTypes.includes(e.detail.type)) {
              this.rightBaseProps.currentComponent = _.cloneDeep(e.detail.toCom)
            }
            this.$set(this.rightTransferProps, e.detail.toCom.code, _.cloneDeep(e.detail.props))
          }
          break
      }
    })
    this.setScale()
    window.onresize = _.debounce(this.setScale, 500)
    window.addEventListener('getOnlineTagList', this.getOnlineTagListHandler)
    window.addEventListener('openYSCameraControl', this.openYSCameraControl)
    window.addEventListener('openVideoDialog', this.openVideoDialog)
    window.addEventListener('gxDialogControl', this.gxDialogControl)
    window.addEventListener('openCollisionEdit', this.openCollisionEdit)
    sessionStorage.removeItem('ToolShowSingleItem')
    sessionStorage.removeItem('ToolShowSingle')
  },
  watch: {
    'leftBaseProps.currentComponent': {
      handler(val) {
        if (!val.code && !this.rightBaseProps.currentComponent.code) {
          this.collapsePanel = false
        }
      },
      deep: true,
    },
    'rightBaseProps.currentComponent': {
      handler(val) {
        if (!val.code && !this.leftBaseProps.currentComponent.code) {
          this.collapsePanel = false
        }
      },
      deep: true,
    },
    'fullScreenBaseProps.currentComponent': {
      handler(val) {
        if (!val.code && !this.fullScreenBaseProps.currentComponent.code) {
          this.collapsePanel = false
        }
      },
      deep: true,
    },
    mode(value) {
      if (value === 'cockpit') {
        this.collapsePanel = true
        this.moveVisualAngleFlag = !this.moveVisualAngleFlag
      } else {
        this.collapsePanel = false
      }
      this.customProps.mode = value
      this.lableDtos = value === 'cockpit' ? this.cockpitLableDtos : this.visualizationLableDtos
      this.defaultLableDtos =
        value === 'cockpit' ? this.cockpitDefaultLableDtos : this.visualizationDefaultLableDtos
    },
  },
  methods: {
    // 宇视摄像头关闭
    refresh() {
      this.cameraPictureTarget.isShowDialog = false
    },
    // 关闭广西定制功能详情弹窗
    closeGxDetail(val) {
      this[val].isShowDialog = false
    },
    // 关闭碰撞检查编辑界面
    closeCollisionEdit() {
      this.collisionEditShow = false
    },
    // 打开碰撞编辑页
    openCollisionEdit(data) {
      console.log('详情', data)
      this.collisionDetail = this.$options.data().collisionDetail
      this.$nextTick(() => {
        this.collisionDetail = data.detail
        this.collisionEditShow = true
      })
    },
    // 打开宇视摄像头
    openYSCameraControl(e) {
      const item = e.detail
      this.cameraPictureTarget = {
        isShowDialog: true,
        deviceCode: item.deviceCode || item.code,
        plid: item.plid || item.pIid,
      }
    },
    // 打开三维监控弹窗
    openVideoDialog(e) {
      const item = e.detail
      this.videoDialogTarget = {
        isShowDialog: true,
        code: item.code || '',
        name: item.name || '',
        manufacturerCode: item.manufacturerCode || 'Hik',
        pIid: item.pIid || '',
        id: item.id || '',
      }
    },
    // 打开详情列表-广西定制
    gxDialogControl(e) {
      const detail = e.detail
      const currentDetail = {
        ...detail,
        isShowDialog: true,
      }
      if (detail.currentDialog && detail.currentDialog === 'valve') {
        // 阀门
        this.currentValve = currentDetail
      } else if (detail.currentDialog && detail.currentDialog === 'blindPlate') {
        // 盲板
        this.currentBlindPlate = currentDetail
      } else if (detail.currentDialog && detail.currentDialog === 'checksAndSets') {
        // 三查四定
        this.currentChecksAndSets = currentDetail
      } else if (detail.currentDialog && detail.currentDialog === 'CrossSectionChart') {
        // 断面分析
        this.CrossSectionChart.isShowDialog = detail.status
        if (detail.type === 'open') {
          this.crossStatus = true
        }
      }
    },
    // 开关动画加载loading(广西石化功能)
    loadingSwitch({ bol, title }) {
      this.animationLoading = bol
      this.loadingTitle = title
    },
    // 切换模型
    changeModel(modelDetail) {
      this.modelDetail = Object.assign(this.modelDetail, modelDetail)
    },
    // 更新装置信息
    updateDeviceInfo(deviceDetail) {
      this.deviceInfo = Object.assign(this.deviceInfo, deviceDetail)
    },
    collisionReloadHandler() {
      // 碰撞功能需要切换加载方式
      if (this.collisionReload) return
      this.modelLoadEnd = false
      console.log('切换回Node加载模型')
      const tempSourceId = this.moduleRelationSceneId
      this.moduleRelationSceneId = 'empty'
      this.collisionReload = true
      setTimeout(() => {
        this.moduleRelationSceneId = tempSourceId
      }, 500)
    },
    progressHandler() {
      // 碰撞功能需要切换回初始加载方式
      if (!this.collisionReload) return
      this.modelLoadEnd = false
      console.log('切换回Model加载模型')
      const tempSourceId = this.moduleRelationSceneId
      this.moduleRelationSceneId = 'empty'
      this.collisionReload = false
      setTimeout(() => {
        this.moduleRelationSceneId = tempSourceId
      }, 500)
    },
    /**
     * @description: 获取功能按钮信息
     * @return {*}
     */
    async getFunctionTabInfo() {
      const [err, res] = await modelGenericConfigurationApi.getList()
      if (!err && res?.items.length) {
        let businessTree = []
        if (res.items[0].extraDto?.businessFunctionTreeList) {
          businessTree = _.filter(res.items[0].extraDto.businessFunctionTreeList, (item) => {
            return !this.gxCustomFunction.includes(item.detail.code)
          })
        }
        this.businessLeftTabList = businessTree
        this.basicFunctionList = res.items[0].extraDto?.basicFunctionTreeList || []
      }
    },
    // 获取模型信息
    async getBaseModelInfo() {
      try {
        const [err, res] = await modelApi.getList({
          directoryId: null,
          name: null,
          skipCount: 0,
          maxResultCount: 99,
        })
        if (!err && res.items.length && this.gxBaseModelName) {
          const modelDetailInfo = _.find(res.items, (item) => {
            return item.name === this.gxBaseModelName
          })
          if (modelDetailInfo) {
            const modelInfo = _.find(modelDetailInfo.medias, ['mediaType', 1])
            const textureInfo = _.find(modelDetailInfo.medias, ['mediaType', 2])
            if (modelInfo?.fileInfoId) {
              this.modelDetail = Object.assign(this.modelDetail, {
                filePath: `data://../apps/${this.modelSetting.folderName}/models/${modelInfo.fileInfoId}/${modelInfo.fileInfoId}.pr`,
                materialFileId: textureInfo ? textureInfo.fileInfoId : '',
                modelFileId: modelInfo.fileInfoId,
              })
            }
          }
        }
        this.GXRunPlayer = true
      } catch (error) {
        console.log('❌ getBaseModelInfo error', error)
        this.GXRunPlayer = true
      }
    },
    /**
     * @description: 获取功能按钮信息
     * @return {*}
     */
    async getGxFunctionInfo(functionCode) {
      const [err, res] = await modelGenericConfigurationApi.getList()
      if (!err && res?.items.length) {
        this.basicFunctionList = res.items[0].extraDto?.basicFunctionTreeList || []
        if (res.items[0].extraDto?.businessFunctionTreeList) {
          let functionList = _.filter(res.items[0].extraDto?.businessFunctionTreeList, (item) => {
            return item.detail.code === 'szh' || item.detail.code === functionCode
          })
          if (functionList) {
            functionList = _.sortBy(functionList, (item) => {
              return item.detail.seqNo
            })
            this.businessLeftTabList.push(...functionList)
          }
        }
      }
    },
    doLocation(data) {
      if (data.from && data.from === 'modelTree') {
        this.updateModelNode(data)
      }
    },
    updateModelNode(node) {
      this.modelNode = node
      console.log('sessionStart', node)
      if (node?.code) {
        console.log('sessionStart', node.code)
        sessionStorage.setItem('svgCode', node.code)
      }
      EventBus.$emit('updateModelNode', node)
    },

    // 关闭分屏
    closeObjInfo() {
      this.modelWidth = 1
    },
    closeObjectFileSplit() {
      this.isSplitScreen = false
    },
    // 退出分屏
    exitScreen(val) {
      this.modelWidth = 1
      if (val === 'objInfo') {
        this.showObjInfoDialog = true
      } else if (val === 'document') {
        this.showDocumentDialog = true
      }
    },
    // 接收场景信息
    setSceneOptions(data) {
      this.$set(this.customProps, 'sceneOptions', data)
    },
    // 标签的改变
    updateLabel([newLabel, oldLabel, isInfloor]) {
      this.labelList = _.cloneDeep(newLabel)
      // 除了在楼层中
      const closeList = []
      _.forEach(newLabel, (item) => {
        _.forEach(oldLabel, (it) => {
          if (item.code === it.code && !item.checked && it.checked) {
            // 如果建筑标签被关闭并且当前正在楼层中，则不关闭建筑详情弹框
            if (!isInfloor || item.code !== 'BuildingList') {
              closeList.push(item)
            }
          }
        })
      })
      this.noticeCloseLabel = closeList
    },
    changePanel() {
      this.collapsePanel = !this.collapsePanel
    },
    toggleMode() {
      this.$emit('toggleMode')
    },
    // 获取放大缩小比例
    getScale() {
      this.style.height =
        window.innerHeight === window.screen.height
          ? 1080
          : 1080 - (window.screen.height - window.innerHeight)
      const w = window.innerWidth / this.style.width
      const h = window.innerHeight / this.style.height
      return `${w},${h}`
    },
    // 设置比例
    setScale() {
      this.style.transform = `scale(${this.getScale()})`
    },
    // 获取数据字典
    async getDataCategory() {
      const [err, res] = await dataCategoryApi.getList({
        keyWord: 'CloudRenderManagement',
        skipCount: 0,
        maxResultCount: 15,
        sorting: 'seqNo asc',
      })
      if (!err && res) {
        const currentCategorie = _.find(res.items, ['code', 'CloudRenderManagement'])
        if (currentCategorie) {
          this.getDataCategoryItems(currentCategorie.id)
        }
      }
    },
    // 获取数据字典项
    async getDataCategoryItems(id) {
      const [err, res] = await dataCategoryApi.get(id)
      if (!err && res) {
        const leftMaxNum = _.find(res.dataItems, ['code', 'leftMaxNum'])
        const rightMaxNum = _.find(res.dataItems, ['code', 'rightMaxNum'])
        const defaultSection = _.find(res.dataItems, ['code', 'defaultSection'])
        this.leftBaseProps.coexistenceNum = Number(leftMaxNum?.data) || 3
        this.rightBaseProps.coexistenceNum = Number(rightMaxNum?.data) || 3
        this.defaultSection = this.$route.query.defaultSection
          ? this.$route.query.defaultSection
          : defaultSection?.data || ''
      }
    },
    // 获取业务功能可视化配置
    async getTabConfigs(id) {
      const [err, res] = await functionInfoApi.get(id)
      if (!err && res) {
        return res.extraDto?.lableDtos
      }
    },
    // 左侧激活的tab
    changeLeftSelectTab(tab) {
      this.leftSelectTab = tab
    },
    // 右侧激活的tab
    changeRightSelectTab(tab) {
      this.rightSelectTab = tab
    },
    // player实例加载完成
    sendPlayer(player) {
      this.player = player
      this.customProps.loadModelStatus = true
    },
    // 模型加载完成
    loadModelEnd(node = null) {
      if (this.player && this.$route.query.kkscode) {
        this.findNodeByCode(this.$route.query.kkscode)
      }
      this.customProps.loadModelStatus = true
      if (this.player) {
        this.showFunctionLabels = true
        this.$emit('loadModelEnd')
      }
      this.currentNode = node
      this.openDeaultComponent()
      this.modelLoadEnd = true
    },

    // 进入页面默认打开Sisystem
    openDeaultComponent(param) {
      const query = param || this.$route.query
      if (query.openDeaultComponent === 'SisSystem' && query.id && !this.isOpenDeaultComponent) {
        this.$set(this.leftBaseProps, 'currentComponent', {
          code: 'SisSystem',
          name: '工艺BIM',
          locationType: 1,
          origin: 'business',
        })
        this.$set(this.leftTransferProps, 'SisSystem', {
          id: query.id,
          toDefaultOpen: 'SisSystem',
        })
        this.isOpenDeaultComponent = true
      }
      if (query.openDeaultComponent && !this.isOpenDeaultComponent) {
        let item = this.businessRightTabList.find((o) => {
          return o.detail.code === query.openDeaultComponent
        })
        if (!item) {
          item = this.businessLeftTabList.find((o) => {
            return o.detail.code === query.openDeaultComponent
          })
          item.position = 'left'
        } else {
          item.position = 'right'
        }

        if (item) {
          const openEvent = new CustomEvent('openComponent', {
            detail: {
              toCom: {
                code: query.openDeaultComponent,
                origin: 'business',
                name: item.detail.name,
                originTagName: query.openDeaultComponent,
              },
              position: item.position,
              type: 'business',
            },
          })
          window.dispatchEvent(openEvent)
        }
      }
    },
    // 打开人员详情
    handlePersonnelInfo() {
      console.log('接收 handlePersonnelInfo')
      // TODO
      // this.activeComponentList.push({
      //   locationType: 2,
      //   code: 'PersonnelInfo',
      // })
      // // 设置作业区域必要参数
      // this.$set(this.rightTransferProps, 'PersonnelInfo', _.cloneDeep())
      // // 关闭全屏弹框
      // if (this.fullScreenBaseProps.currentComponent.code) {
      //   this.fullScreenCloseComponent(this.fullScreenBaseProps.currentComponent, true)
      // }
      // // this.rightBaseProps.currentComponent = params
      // this.collapsePanel = false
    },
    // 获取场景信息
    async getSceneInfo() {
      const [jsonErr, jsonRes] = await modelSceneApi.getModelSecenRelatedJson({
        id: this.moduleRelationSceneId,
      })
      if (!jsonErr) {
        return JSON.parse(jsonRes)
      }
      return null
    },
    // 打开作业区域弹窗
    handleJobArea(params = null) {
      // this.rightTransferProps
      // 打开作业区域弹窗
      if (params && params.open) {
        this.activeComponentList.push({
          locationType: params.locationType,
          code: params.code,
        })
        // params.areaId = '06322299-e577-58e6-6fd2-3a1703dec976'
        // 设置作业区域必要参数
        this.$set(this.rightTransferProps, params.code, _.cloneDeep(params))
        console.log('打开作业区域弹窗', this.rightTransferProps)
        // 关闭全屏弹框
        if (this.fullScreenBaseProps.currentComponent.code) {
          this.fullScreenCloseComponent(this.fullScreenBaseProps.currentComponent, true)
        }
        this.rightBaseProps.currentComponent = params
        this.collapsePanel = false
        return
      }
      // 关闭作业区域弹窗
      if (params && !params.open) {
        const codeList =
          this.activeComponentList.map((item) => {
            return item.code
          }) || []
        if (codeList.includes(params.code)) {
          this.activeComponentList = this.activeComponentList.filter((item) => {
            return item.code !== params.code
          })
        }
        if (this.$refs.rightComponentContainer) {
          this.$refs.rightComponentContainer.handleExtraRemoveTag(params)
        }
      }
    },
    async tabsClick(arg, type) {
      // 定制化加载模型-start
      // if (arg[0].code === 'MetalBim') {
      //   this.moduleRelationSceneId = this.metalBIMmodelId
      // }
      // 定制化加载模型-end
      this.noticeCloseComponent = {}
      const tabDetail = arg[0]
      if (tabDetail.code === 'typhoon') {
        this.$router.push({
          name: 'preventionHome',
          params: {
            path: this.$routlllle.path,
            defaultSection: this.locationType,
          },
        })
        return
      }
      if (tabDetail.code === 'EmergencyDisposalDyw') {
        this.emergencyDisposalDyw.isShowDialog = true
        return
      }
      // jumpAddressConfig配置跳转其他页面，不打开页面组件
      const jumpAddressConfig = this.visualizationCockpitConfig?.jumpAddressConfig || {}
      const url = jumpAddressConfig[tabDetail.code]
      if (url) {
        window.open(url)
        return
      }

      if (type === 'basic') {
        if (tabDetail.code === 'HomeView') {
          const [err, res] = await HandoverService.getViewPoint({
            sceneId: this.moduleRelationSceneId,
            userId: Wiz.AuthHooks.GetUserInfo().profile.sub,
          })
          if (!err && res.angle) {
            const { eye, target, up } = JSON.parse(res.angle)
            return this.player.Native.Camera.addMoveTo(eye, target, up, 2)
          }
          const jsonData = await this.getSceneInfo()
          if (jsonData.cameraParams) {
            const { eye, target, up } = JSON.parse(jsonData.cameraParams)
            await this.player.Native.Camera.addMoveTo(eye, target, up, 2)
          }
          return
        }

        if (_.includes(this.showHidenCodeList, tabDetail.code)) {
          const currentSelectItem = await this.player.Native.Node.getSeletedNodes()
          tabDetail.code === 'system.ToolShowSingle' &&
            sessionStorage.setItem('ToolShowSingle', this.customProps.modelTreeProp.spaceSwapStatus)
          setModelVisible(
            this.player,
            tabDetail.code,
            true,
            currentSelectItem,
            this.customProps.modelTreeProp
          )
          return
        }
        if (this.activeBasicList.indexOf(tabDetail.code) !== -1) {
          this.activeBasicList.splice(this.activeBasicList.indexOf(tabDetail.code), 1)
          this.activeBasic = ''
          if (tabDetail.locationType === 0) {
            // TODO: 移除
            this.noticeCloseComponent = tabDetail
            // 销毁关闭的基础功能相关设置
            const closeRes = await destroyCloseBasicTab(tabDetail.code, this.player)
            return
          }
          this.noticeCloseComponent = tabDetail
          return
        }
        this.activeBasicList.push(tabDetail.code)
        this.activeBasic = tabDetail.code
        // TODO: 设置功能
        // 激活当前点击基础功能
        const openRes = await initActiveBasicTab(tabDetail.code, this.player, this.activeBasicList)
      }
      // 设置配置
      const configList = await this.getTabConfigs(tabDetail.id)
      this.businessTabConfigs = _.map(configList, (item) => {
        return { id: item.id, code: item.code, name: item.name, origin: tabDetail.code }
      })
      if (tabDetail.locationType === 0) {
        // TODO: 设置功能
        return
      }
      this.activeComponentList.push({
        locationType: tabDetail.locationType,
        code: tabDetail.code,
      })
      // 关闭全屏弹框
      if (this.fullScreenBaseProps.currentComponent.code) {
        this.fullScreenCloseComponent(this.fullScreenBaseProps.currentComponent, true)
      }
      switch (tabDetail.locationType) {
        case 0:
          // 默认，不打开弹框
          break
        case 1:
          // 左侧弹框
          this.leftBaseProps.currentComponent = tabDetail
          this.collapsePanel = false
          this.emergencyDisposalDyw.isShowDialog = false
          break
        case 2:
          // 右侧弹框
          this.rightBaseProps.currentComponent = tabDetail
          this.collapsePanel = false
          break
        case 3:
          // 全屏弹框
          this.fullScreenBaseProps.currentComponent = tabDetail
          this.collapsePanel = false
          break
        default:
          break
      }
    },
    async changeModule(moduleItem) {
      this.locationType = moduleItem.functionLocationType
      const sceneId = this.mode === 'cockpit' ? moduleItem.cockpitSceneId : moduleItem.sceneId
      this.customProps.loadModelStatus = this.moduleRelationSceneId === sceneId
      this.moduleRelationSceneId = sceneId
      this.$emit('updateSceneId', sceneId)
      this.customProps.sceneId = sceneId
      await this.getSectionsDetail(moduleItem.id)
      this.rightBaseProps.currentComponent = {}
      this.leftBaseProps.currentComponent = {}
      this.fullScreenBaseProps.currentComponent = {}
      this.rightSelectTab = ''
      this.leftSelectTab = ''
      this.$emit('changeModule', moduleItem)
      if (!this.isJumpSectionOver) {
        this.jumpFunction = { code: _.cloneDeep(this.recordCode) }
        this.isJumpSectionOver = true
      }
    },
    // 点击报警消息跳转
    alarmJump([jumpSection, code]) {
      // 如果需要跳转的板块就是当前的板块，则直接打开功能
      if (this.locationType === jumpSection.functionLocationType) {
        this.jumpFunction = { code: _.cloneDeep(code) }
      } else {
        // 如果不是当前板块，则先跳转到对应板块再打开功能
        this.isJumpSectionOver = false
        // 记录需要跳转功能的code
        this.recordCode = _.cloneDeep(code)
        this.alarmJumpSection = jumpSection
      }
    },

    order(list) {
      const arr = _.orderBy(list, 'detail.seqNo')

      for (let index = 0; index < arr.length; index++) {
        const element = arr[index]
        if (element.children.length !== 0) {
          element.children = this.order(element.children)
        }
      }
      return arr
    },
    /**
     * @description: 获取板块的id
     * @param {*} id
     * @return {*}
     */

    async getSectionsDetail(id) {
      const currentApi = this.visualizationConfig.showRightPanel ? huizhouSectionApi : sectionApi
      const [err, res] = await currentApi.get(id)
      if (!err && res) {
        this.businessLeftTabList = res.extraDto?.businessFunctionTreeList
          ? this.order(res.extraDto?.businessFunctionTreeList)
          : []
        this.businessRightTabList = res.extraDto?.businessFunctionRightTreeList
          ? this.order(res.extraDto?.businessFunctionRightTreeList)
          : []
        this.businessFunctionCodes = [
          ..._.map(res.extraDto?.businessFunctionInfoDtos, 'code'),
          ..._.map(res.extraDto?.businessFunctionRightInfoDtos, 'code'),
        ]
        this.basicFunctionList = res.extraDto?.basicFunctionTreeList || []

        this.visualizationLableDtos = res.extraDto?.lableDtos || []
        this.visualizationDefaultLableDtos = res.extraDto?.defaultLableDtos || []
        this.cockpitLableDtos = res.extraDto?.cockpitLableDtos || []
        this.cockpitDefaultLableDtos = res.extraDto?.cockpitDefaultLableDtos || []

        this.lableDtos =
          this.mode === 'cockpit' ? this.cockpitLableDtos : this.visualizationLableDtos
        this.defaultLableDtos =
          this.mode === 'cockpit'
            ? this.cockpitDefaultLableDtos
            : this.visualizationDefaultLableDtos
      }
    },
    // 左侧容器事件触发
    leftTransferEvent(data) {
      console.log('transferEvent-11111', data)

      if (data.toCom.code === 'NewCollisionCheck' && data.props && data.props.materialObj) {
        this.materialObj = data.props.materialObj
      }
      // 移交文档(分屏功能，模型只展示屏幕的一半，另一半展示文档的文件)
      if (data.toCom.code === 'ObjectInfoDyw' && data.props && data.props.width) {
        this.moduleType = 'document'
        this.modelWidth = 1 / 2
        this.objInfoWidth = `${data.props.width}px`
        this.objInfoHeight = `${data.props.height}px`
        this.showDocumentDialog = false
        this.objInfoMsg = data.props.dialogForm
        this.standardId = data.props.standardId
        return
      }
      if (this.openComTypes.includes(data.type)) {
        this.rightBaseProps.currentComponent = _.cloneDeep(data.toCom)
      }
      this.$set(this.rightTransferProps, data.toCom.code, _.cloneDeep(data.props))
      if (data.props?.controlAlarm) {
        // 控制闪烁
        this.openAlarmFlicker = !!data.props?.openAlarmFlicker
      }
      this.alarmFlickerFrequency =
        data.props?.flickerFrequency &&
        _.isNumber(data.props?.flickerFrequency) &&
        _.toNumber(data.props?.flickerFrequency) > 0
          ? data.props?.flickerFrequency
          : 500
    },
    // 右侧容器事件触发
    rightTransferEvent(data) {
      if (data.type === 'transferData') {
        return this.$set(this.leftTransferProps, data.code, _.cloneDeep(data.data))
      }
      if (data.toCom.code === 'ObjectFileSplit') {
        this.objInfoMsg = data.props.formData
        this.standardId = data.props.standardId
        this.isSplitScreen = false
        this.$nextTick(() => {
          this.isSplitScreen = true
        })
        return
      }
      // 对象信息(分屏功能，模型只展示屏幕的一半，另一半展示对象信息的文件)
      if (data.toCom.code === 'HandoverObject' && data.props.width) {
        this.moduleType = 'objInfo'
        this.modelWidth = 1 / 2
        this.objInfoWidth = `${data.props.width}px`
        this.objInfoHeight = `${data.props.height}px`
        this.showObjInfoDialog = false
        this.objInfoMsg = data.props.dialogForm
        this.standardId = data.props.standardId
        return
      }
      if (this.openComTypes.includes(data.type)) {
        this.leftBaseProps.currentComponent = _.cloneDeep(data.toCom)
      }
      this.$set(this.leftTransferProps, data.toCom.code, _.cloneDeep(data.props))
      if (data.props?.controlAlarm) {
        // 控制闪烁
        this.openAlarmFlicker = !!data.props?.openAlarmFlicker
      }
      this.alarmFlickerFrequency =
        data.props?.alarmFlickerFrequency &&
        _.isNumber(data.props?.alarmFlickerFrequency) &&
        _.toNumber(data.props?.alarmFlickerFrequency) > 0
          ? data.props?.alarmFlickerFrequency
          : 500
    },
    // 全屏容器事件触发
    fullScreenTransferEvent(data) {
      if (this.openComTypes.includes(data.type)) {
        this.fullScreenBaseProps.currentComponent = _.cloneDeep(data.toCom)
      }
      this.$set(this.fullScreenTransferProps, data.toCom.code, _.cloneDeep(data.props))
      if (data.props?.controlAlarm) {
        // 控制闪烁
        this.openAlarmFlicker = !!data.props?.openAlarmFlicker
      }
      this.alarmFlickerFrequency =
        data.props?.alarmFlickerFrequency &&
        _.isNumber(data.props?.alarmFlickerFrequency) &&
        _.toNumber(data.props?.alarmFlickerFrequency) > 0
          ? data.props?.alarmFlickerFrequency
          : 500
    },
    // 左侧组件关闭事件
    leftCloseComponent(val, isEmpty) {
      if (val.code === 'CrossSectionAnalysis') {
        this.CrossSectionChart.isShowDialog = false
        this.crossStatus = false
      }
      // 定制化加载模型-start
      // if (val.code === 'MetalBim') {
      //   this.moduleRelationSceneId = this.customProps.sceneId
      // }
      // 定制化加载模型-end
      this.noticeCloseComponent = val
      if (isEmpty) {
        this.leftBaseProps.currentComponent = {}
        this.leftTransferProps = {}
      }
      this.cancelBasicStatus(val)
    },
    // 右侧组件关闭事件
    rightCloseComponent(val, isEmpty) {
      this.noticeCloseComponent = val
      if (isEmpty) {
        this.rightBaseProps.currentComponent = {}
        this.rightTransferProps = {}
      }
      this.cancelBasicStatus(val)
    },
    // 全屏组件关闭事件
    fullScreenCloseComponent(val, isEmpty) {
      this.noticeCloseComponent = val
      if (isEmpty) {
        this.fullScreenBaseProps.currentComponent = {}
        this.fullScreenTransferProps = {}
      }
      this.cancelBasicStatus(val)
    },
    cancelBasicStatus(val) {
      if (this.activeBasicList.includes(val.code)) {
        this.activeBasicList.splice(this.activeBasicList.indexOf(val.code), 1)
        this.activeBasic = ''
      }
    },
    // 获取当前在线人员列表
    getOnlineTagListHandler(e) {
      this.onlineTagList = e?.detail?.onlineTagList
    },
    // 操作历史轨迹
    operateTrajectory({ visible, personnelId, tagCode }) {
      this.trajectoryVisible = visible
      this.trajectoryProps.personnelId = personnelId
      this.trajectoryProps.tagCode = tagCode
    },
    // 历史轨迹加载完成
    loadHistoryTrialEnd() {
      const trajectoryEndEvent = new CustomEvent('loadHistoryTrialEnd')
      window.dispatchEvent(trajectoryEndEvent)
    },
    openDialog(params) {
      if (!_.includes(this.businessFunctionCodes, params?.code)) {
        if (params?.code === 'EmergencyDisposal') {
          return this.$message.warning({
            showClose: true,
            message: '当前板块没有配置应急一张图功能',
          })
        }
        if (params?.code === 'OperationSafetyPage') {
          return this.$message.warning({
            showClose: true,
            message: '当前板块没有配置作业一张图功能',
          })
        }
      }
      this.jumpFunction = params
    },
    // 地球动画结束（因为定时器实现，这是大概时间，不能作为准确时间去使用）
    animationEnd(data) {
      this.$emit('animationEnd', data)
    },
    /**
     * 以下方法为实现路由传kks跳模型
     */
    // 通过kks码定位模型设备区域
    async findNodeByCode(code) {
      const codeInfo = await this.player.Native.Node.findNodeByCode(0, decodeURIComponent(code))
      if (codeInfo) {
        await this.player.Native.Camera.moveToNode(codeInfo, 1) // 相机跳转
        await this.player.Native.Node.selectNodes([codeInfo]) // 模型选中
      } else {
        console.log('kks跳转模型失败', codeInfo)
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('getOnlineTagList', this.getOnlineTagListHandler)
    localStorage.removeItem('currentModelNodeCode')
    if (this.player) {
      this.cloudRender.Engine.destroyEngine()
    }
  },
}
</script>
<style lang="scss">
@import '@/assets/css/popover';
@import '../../../assets/css/cyan';
</style>
<style lang="scss" scoped>
@import '@/assets/css/index';

.control-panel {
  background-image: url('../assets/images/control/collapse.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.unfold {
  transform: rotateZ(180deg);
}

.collapse {
  transform: rotateZ(0deg);
}

.visualization-cockpit {
  transform-origin: top left;
}

.left-wide-mask {
  background-image: var(--leftWideMask);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.left-narrow-mask {
  background-image: var(--leftNarrowMask);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.right-narrow-mask {
  background-image: var(--leftNarrowMask);
  transform: rotateZ(180deg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.right-wide-mask {
  background-image: var(--rightMask);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.loading-action {
  background: url('../assets/images/loading.png') no-repeat;
  background-size: 100% 100%;
  animation: rotation 3s linear infinite;
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
